export const globalS2sConfig: PrebidConfig = {
  cache: {
    url: "https://prebid-server.rubiconproject.com/cache",
    ignoreBidderCacheKey: true,
  },
  s2sConfig: [],
};
